import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]
  static values = { enabled: Boolean }

  connect() {
    const storedState = sessionStorage.getItem("weekday-filter") === "true"
    this.checkboxTarget.checked = storedState
    this.filterTimesheets()
  }

  filterTimesheets() {
    const showWeekdays = this.checkboxTarget.checked
    sessionStorage.setItem("weekday-filter", showWeekdays)
    const timesheets = document.querySelectorAll("[data-reported-date]")

    timesheets.forEach((timesheet) => {
      const dateStr = timesheet.dataset.reportedDate
      const date = new Date(dateStr)
      const dayOfWeek = date.getDay()

      if (showWeekdays) {
        timesheet.style.display = dayOfWeek === 0 || dayOfWeek === 6 ? "none" : ""
      } else {
        timesheet.style.display = ""
      }
    })
  }
}
